var map = {
	"./奖励底板.png": 856597,
	"./开奖记录.png": 600069,
	"./弹幕头像框.png": 776657,
	"./弹幕底板.png": 991932,
	"./未选中tab.png": 821887,
	"./空状态.png": 141617,
	"./记录底板.png": 606155,
	"./选中tab.png": 488631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 324863;